export default class PontoFocalData {
    id = null
    document = null
    nome = null
    dataNascimento = null
    email = null
    telefone = null
    cargo = null
}



// WEBPACK FOOTER //
// ./src/shared/models/configurations/pontofocalmodel.js